<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">INCIDENCIAS REGISTRADAS</h5>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-striped table-bordered">
          <thead>
          <tr>
          <th>
            <select
                class="custom-select"
                v-model="seleccionado"
                @change="getConfigEmpresa()"
            >
              <option value="">SELECCIONAR EMPRESA</option>
              <option
                  v-for="(t, i) in vempresas"
                  :value="t.id_empresa"
                  :key="t.nombre_empresa + i"
              >{{ t.nombre_empresa}}</option
              >
            </select>
          </th>
            <th>
              <select
                  class="custom-select"
                  v-model="vueloselec"
              >
                <option value="">SELECCIONAR VUELO</option>
                <option
                    v-for="(t, i) in confempresa"
                    :value="t.id_config_empresa"
                    :key="i"
                >{{ t.nro_vuelo}}</option
                >
              </select>
            </th>
            <th>
              <button class="btn btn-success" type="button" @click="crearReporte()">
                Reportar Incidencia
                <i class="fa fa-plus"></i>
              </button>
            </th>
            <th>
              <button class="btn btn-success mx-1" type="button" @click="imprime()">

                <i class="fa fa-file-pdf-o"></i>
              </button>
              <button class="btn btn-success mx-1" type="button" @click="imprimExel()">

                <i class="fa fa-file-excel-o"></i>
              </button>

            </th>
            <th>
              <button class="btn btn-info mx-2" type="button" @click="obtenerIncidenciasGen()">
                Buscar
                <i class="fa fa-search"></i>
              </button>
            </th>
          </tr>
          <tr>
            <th colspan="3">
              <b-row>
                <b-col md="7">
                  <b-form-datepicker
                      id="fecha-inicial"
                      placeholder="Seleccione fecha inicio"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      v-model="fecha_ini"
                  >
                  </b-form-datepicker>
                </b-col>
                <!--@input="fechaInicial"-->
                <b-col md="5">
                  <b-form-timepicker
                      placeholder="Hora"
                      id="ex-disabled-readonly"
                      v-model="hora_ini"
                  >
                  </b-form-timepicker>
                </b-col>
              </b-row>
            </th>
            <th colspan="2">
              <b-row>
                <b-col md="8">
                  <b-form-datepicker
                      id="fecha-final"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      placeholder="Seleccione fecha final"
                      v-model="fecha_fin"

                      locale="es">
                  </b-form-datepicker>
                  <!--@input="fechaFinal"-->
                </b-col>
                <b-col md="4">
                  <b-form-timepicker
                      v-model="hora_fin"
                      id="ex-disabled-readonly"
                      placeholder="Hora"
                  ></b-form-timepicker>
                </b-col>
              </b-row>
            </th>
          </tr>

          </thead>
          <tbody v-for="(itemes, index) in incidenciasgen" :key="index+20">

            <tr>
            <td colspan="10"><h1>{{itemes.nombre}}</h1></td>
            </tr>
            <tr class="text-center">
              <th>
                <small class="font-weight-bold">FRONTERA</small>
              </th>
              <th><small class="font-weight-bold">FECHA</small></th>
              <th><small class="font-weight-bold">OBSERVACION</small></th>
              <th><small class="font-weight-bold">RESPUESTA</small></th>
              <th><small class="font-weight-bold">VER DETALLE</small></th>
            </tr>
            <tr v-for="(item, index) in itemes.data" :key="index">
            <td>
              <small>{{ item.cod_frontera }}</small>
            </td>
            <td class="text-center">
              <small> {{ new moment(item.fecha_reg).format("DD-MM-YYYY HH:MM:SS") }}</small>
            </td>
            <td class="text-center">
              {{item.observacion}}
            </td>
            <td class="text-center">
              {{item.respuesta_dev}}
            </td>
            <td class="text-center">
              <button
                  class="btn btn-success"
                  type="button"
                  @click="obtenerIncidenciasDetalle(item.idincidencias_gen,item.cod_frontera)"
              ><i class="fa fa-bars"> Ver</i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        </div>
    </div>
    </div>
    <Loading v-show="cargando" />
    <b-modal
        class="modal fade"
        title="Observaciones"
        size="xl"
        hide-footer
        ref="modalObservacion"
        :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-bordered table-condensed">

              <thead>

              <tr class="text-center">
                <th><small class="font-weight-bold">NOMBRE FRONTERA</small></th>
                <th><small class="font-weight-bold">EQUIPO</small></th>
                <th><small class="font-weight-bold">ERROR</small></th>
                <th><small class="font-weight-bold">EN CASO DE OTRO</small></th>
                <th><small class="font-weight-bold">ESTADO</small></th>
                <th><small class="font-weight-bold">RESPUESTA</small></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in incidenciasdet" :key="index">
                <td>
                  <small>{{ item.cod_frontera }}</small>
                </td>
                <td class="text-center">
                  <small> {{ item.equipo }}</small>
                </td>
                <td class="text-center">
                  {{item.nombre}}
                </td>
                <td class="text-center">
                  {{item.observacion_equipo}}
                </td>
                <td class="text-center">
                  {{(item.estado_registro == 1 )?'REPORTADO':'SOLUCIONADO'}}
                </td>
                <td class="text-center">
                  {{item.solucion_soporte}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
//import { required } from "vuelidate/lib/validators";
export default {
  name: "listaRobot",
  components: {
    Loading,
  },
  data() {
    return {
      seleccionado:'',
      seleccionadoerr1:'',
      seleccionadoerr2:'',
      seleccionadoerr3:'',
      seleccionadoerr4:'',
      seleccionadoerr5:'',
      id_config_flujo:null,
      vueloselec:'',
      fields:[],
      hora_ini:'00:00:00',
      hora_fin:'23:59:59',
      vempresas:[],
      confempresa:[],
      dataenv:{},
      perPage: 3,
      currentPage: 1,

      parametro: '',
      incidenciasgenNew:[],
      incidenciasgen:[],
      incidenciasdet:[],
      observacion : {
        descripcion:'',
        vuelo:'',
        fecha:'28/01/16'
      },
      observaciones:[],
      cargando: false,
      erroresUno:[],
      erroresDos:[],
      erroresTres:[],
      erroresCuatro:[],
      erroresCinco:[],
      fecha_ini:null,
      fecha_fin: null
    };
  },
  methods: {

    async getNombreEmpresas() {
      try {
        let resultados = await this.axios.get(`/getEmpresaVuelo`);
        //console.log(resultados, "hOLA" );
        this.vempresas = resultados.data.contenido;
       //console.log(this.vempresas );
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getConfigEmpresa() {
      this.cargando = true;
      try {
        this.cargando = false;
        let resultados = await this.axios.get(`/getConfigempresa/${this.seleccionado}`);
        this.confempresa = resultados.data.contenido;
       // console.log(this.confempresa);
        this.cargando = false;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async obtenerIncidenciasGen(){
    try {
      let hora_ini_aux=(this.hora_ini == '')?'':' '+this.hora_ini;
      let hora_fin_aux=(this.hora_fin == '')?'':' '+this.hora_fin;
      ///${id_config_flujo}/${fecha_ini}/${fecha_fin}
      let resultados = await this.axios.get(`/incidencias-gen/${this.id_config_flujo}/${this.fecha_ini}${hora_ini_aux}/${this.fecha_fin}${hora_fin_aux}`);
      this.incidenciasgen =  resultados.data.contenido;
      console.log(this.incidenciasgen);
    } catch (error){
      console.log("catch: ", error);
    }
    },
    async imprime() {
     // console.log("Hola Mundo")
      let config = { headers: { token: this.token }, responseType: "blob" };

      try {
        let resultados = await this.axios.get(`/incidencias-gen-pdf/${this.id_config_flujo}/${this.fecha_ini}/${this.fecha_fin}`,config);
        // console.log(resultados)
        await this.crearDescarga(resultados, "reporte.pdf");
      } catch (error) {
        console.log(error);
      }
    },
    async imprimExel() {
      // console.log("Hola Mundo")
      let config = { headers: { token: this.token }, responseType: "blob" };

      try {
        let resultados = await this.axios.get(`/incidencias-gen-xls/${this.id_config_flujo}/${this.fecha_ini}/${this.fecha_fin}`,config);
        // console.log(resultados)
        await this.crearDescarga(resultados, 'reporte.xlsx');
      } catch (error) {
        console.log(error);
      }
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "blob" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    async obtenerIncidenciasDetalle(id, id_from){
      this.$refs["modalObservacion"].show();
      try {
        let resultados = await this.axios.get(`/incidencias-det/${id}/${id_from}`);
        this.incidenciasdet= resultados.data.contenido;
      console.log(this.incidenciasdet);
      } catch (error){
        console.log("catch: ", error);
      }
    },
    async obtenerErrores(){
      let resultados = await this.axios.get(`/errores`);
      this.erroresUno= resultados.data.contenido;
    },
    onChangeCentro(){

    },
    onChange(){
      this.id_config_flujo=this.vueloselec;
      this.obtenerIncidenciasGen()
    },
    async fechaInicial(value){
      this.fecha_ini = value

      this.obtenerIncidenciasGen()
    },
    async fechaFinal(value){
      this.fecha_fin = value
      this.obtenerIncidenciasGen()
    },

    hideModalObservado() {
      this.$refs["modalObservacion"].hide();
    },
    seleccionarError(item){
      item.observacion_equipo = "";
    },
    crearReporte(){
      this.$router.push('crearReporte');
    },
  },
  created() {
        this.obtenerErrores(),
        this.getNombreEmpresas(),
        this.obtenerIncidenciasGen()
  },

};
</script>
